import { render } from "./custom_select2.vue?vue&type=template&id=77c80500"
import script from "./custom_select2.vue?vue&type=script&lang=js"
export * from "./custom_select2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__